import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LoginService } from '../services/login/login.service';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(
        private router: Router,
        private loginService: LoginService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot, ): Observable<boolean> | Promise<boolean> | boolean {

        return new Promise(resolve => {
            const segment = next.url
            const isLogged = this.loginService.isLogin()
            if (isLogged) {
                //console.log('LOGIN GUARD SAY: user is logged in')
                resolve(true)
            } else {
                localStorage.clear()
                this.router.navigate(["/"])
                resolve(false)
            }
        })

    }
}



// WEBPACK FOOTER //
// ./src/app/guards/login.guard.ts